import { z } from 'zod'

export const LEARNING_ARTIFACTS_WRITE_CONTRACT_VERSION = '1.0.0' as const
export const LEARNING_ARTIFACTS_SCHEMA_VERSION = 'learning-artifacts-v1' as const

const schemaVersion = z.object({ schemaVersion: z.literal(LEARNING_ARTIFACTS_SCHEMA_VERSION) })
const requiredText = z.string().trim().min(1).max(240)
const storageUri = z.string().trim().min(1).max(2048).refine((value) => value.startsWith('object://') || value.startsWith('r2://'), 'Storage URI must target object storage.')
const sha256 = z.string().trim().regex(/^(sha256:)?[a-f0-9]{64}$/)
const manifest = z.record(z.unknown())
const item = z.record(z.unknown())
const itemResponse = z.object({ contract_version: z.literal(LEARNING_ARTIFACTS_WRITE_CONTRACT_VERSION), item }).passthrough()

export const learningArtifactRegisterRequestSchema = schemaVersion.extend({
  catalogNodeId: requiredText,
  version: requiredText,
  storageUri,
  sha256,
  manifest,
  admissionStatus: z.enum(['pending', 'accepted', 'rejected', 'revoked']).optional(),
}).strict()
export const learningExportPackageRegisterRequestSchema = schemaVersion.extend({
  catalogNodeId: requiredText,
  sourceArtifactId: requiredText.nullable().optional(),
  packageFamily: z.enum(['scorm', 'common_cartridge', 'cmi5', 'standalone_spa', 'lms_specific']),
  packageSchemaVersion: requiredText,
  version: requiredText,
  storageUri,
  sha256,
  manifest,
  admissionStatus: z.enum(['pending', 'accepted', 'rejected', 'revoked']).optional(),
}).strict()
export const learningArtifactPublishRequestSchema = schemaVersion.extend({
  releaseChannel: z.enum(['preview', 'production']),
}).strict()
export const learningArtifactActionRequestSchema = z.object({}).passthrough()

export const learningArtifactRegisterResponseSchema = itemResponse
export const learningArtifactVerifyHashResponseSchema = itemResponse
export const learningArtifactPublishResponseSchema = itemResponse
export const learningArtifactRollbackResponseSchema = itemResponse
export const learningExportPackageRegisterResponseSchema = itemResponse
export const learningExportPackageVerifyHashResponseSchema = itemResponse
export const learningExportPackagePublishResponseSchema = itemResponse
export const learningExportPackageRollbackResponseSchema = itemResponse

export const learningArtifactsWriteErrorEnvelopeSchema = z.object({
  contract_version: z.literal(LEARNING_ARTIFACTS_WRITE_CONTRACT_VERSION),
  error: z.object({ code: z.string(), message: z.string() }).passthrough(),
}).passthrough()

export type LearningArtifactRegisterRequest = z.infer<typeof learningArtifactRegisterRequestSchema>
export type LearningExportPackageRegisterRequest = z.infer<typeof learningExportPackageRegisterRequestSchema>
export type LearningArtifactPublishRequest = z.infer<typeof learningArtifactPublishRequestSchema>
export type LearningArtifactActionRequest = z.infer<typeof learningArtifactActionRequestSchema>
export type LearningArtifactRegisterResponse = z.infer<typeof learningArtifactRegisterResponseSchema>
export type LearningArtifactVerifyHashResponse = z.infer<typeof learningArtifactVerifyHashResponseSchema>
export type LearningArtifactPublishResponse = z.infer<typeof learningArtifactPublishResponseSchema>
export type LearningArtifactRollbackResponse = z.infer<typeof learningArtifactRollbackResponseSchema>
export type LearningExportPackageRegisterResponse = z.infer<typeof learningExportPackageRegisterResponseSchema>
export type LearningExportPackageVerifyHashResponse = z.infer<typeof learningExportPackageVerifyHashResponseSchema>
export type LearningExportPackagePublishResponse = z.infer<typeof learningExportPackagePublishResponseSchema>
export type LearningExportPackageRollbackResponse = z.infer<typeof learningExportPackageRollbackResponseSchema>
